export default __webpack_public_path__ + "static/media/default.5ff58ba8.png";